<script setup lang="ts">
import {computed} from 'vue';
import VChart from 'vue-echarts';
import type {EChartsOption, SeriesOption} from 'echarts';
import '@/base/echarts.js';
import {formatFte, ImpactPerOrganisatie, KLEUR_BALK} from 'common';

const KLEUR_WEL: string  = KLEUR_BALK.groen;
const KLEUR_NIET: string = '#d8e6f7';
const KLEUR_TICK: string = '#23272d';

const props = defineProps<{
    impact: ImpactPerOrganisatie[];
}>();

// largest identified impact at the top
const gesorteerd = computed<ImpactPerOrganisatie[]>(() => [...props.impact].sort((a, b) => (a.welInUitvoering + a.nietInUitvoering) - (b.welInUitvoering + b.nietInUitvoering)));

function balk(naam: string, kleur: string, waarden: number[]): SeriesOption {
    return {type: 'bar', name: naam, stack: 'impact', data: waarden, itemStyle: {color: kleur}, label: {show: true, position: 'inside', formatter: (p: {value: number}) => p.value === 0 ? '' : formatFte(p.value)}} as unknown as SeriesOption;
}

const option = computed<EChartsOption>(() => ({
    grid   : {left: 8, right: 60, top: 32, bottom: 28, containLabel: true},
    legend : {top: 0},
    tooltip: {trigger: 'axis', valueFormatter: (v: unknown) => formatFte(Number(v))},
    xAxis  : {type: 'value', name: 'Geidentificeerde impact (FTE)', nameLocation: 'middle', nameGap: 24},
    yAxis  : {type: 'category', data: gesorteerd.value.map(i => i.organisatie)},
    series : [
        balk('Wel in uitvoering', KLEUR_WEL, gesorteerd.value.map(i => i.welInUitvoering)),
        balk('Niet in uitvoering', KLEUR_NIET, gesorteerd.value.map(i => i.nietInUitvoering)),
        {
            type      : 'scatter',
            name      : 'Target',
            symbol    : 'rect',
            symbolSize: [3, 22],
            itemStyle : {color: KLEUR_TICK},
            data      : gesorteerd.value.map(i => [i.targetQ ?? null, i.organisatie]),
        } as unknown as SeriesOption,
    ],
}));
</script>

<template>
    <v-chart :option="option" autoresize :style="{height: `${80 + 40 * impact.length}px`, width: '100%'}"/>
</template>
